<div class="checklist-signoff">
	<section class="checklist-signoff__section">
		<div class="checklist-signoff__header">
			<span class="checklist-signoff__header-title">Instructor Sign-off</span>
		</div>

		<div class="checklist-signoff__body">
			<div class="checklist-signoff__field">
				<label class="checklist-signoff__label">Instructor Name</label>
				<div class="checklist-signoff__underline">
					<span class="checklist-signoff__value">{{ instructor?.name || "—" }}</span>
				</div>
			</div>

			<div class="checklist-signoff__field">
				<label class="checklist-signoff__label">License No</label>
				<div class="checklist-signoff__underline">
					<span class="checklist-signoff__value">{{ instructor?.licenseNumber || "—" }}</span>
				</div>
			</div>

			<div class="checklist-signoff__field">
				<label class="checklist-signoff__label">Instructor Signature</label>
				<div class="checklist-signoff__signature-wrap">
					@if (hasInstructorSignature) {
						<div class="checklist-signoff__signature checklist-signoff__signature--readonly">
							<img
								class="checklist-signoff__signature-img"
								[src]="instructor!.signatureDataUrl"
								alt="Instructor signature"
							/>
						</div>
						@if (instructor?.signedAt) {
							<span class="checklist-signoff__signed-at">{{ instructor!.signedAt }}</span>
						}
					} @else {
						<span class="checklist-signoff__placeholder">—</span>
					}
				</div>
			</div>
		</div>
	</section>

	<section class="checklist-signoff__section">
		<div class="checklist-signoff__header">
			<span class="checklist-signoff__header-title">Candidate Sign-off</span>
		</div>

		<div class="checklist-signoff__body">
			<p class="checklist-signoff__disclaimer">
				The candidate has reviewed the results of the training session and agrees with the assessment conducted.
			</p>

			<div class="checklist-signoff__field">
				<label class="checklist-signoff__label">Candidate Name</label>
				<div class="checklist-signoff__underline">
					<span class="checklist-signoff__value">{{ candidateName || "—" }}</span>
				</div>
			</div>

			<div class="checklist-signoff__field">
				<label class="checklist-signoff__label">Candidate Signature</label>
				<div class="checklist-signoff__signature-wrap">
					<button type="button" class="checklist-signoff__signature" [disabled]="signing" (click)="sign.emit()">
						@if (hasCandidateSignature) {
							<img
								class="checklist-signoff__signature-img"
								[src]="candidateSignaturePreview"
								alt="Candidate signature"
							/>
						} @else {
							<span class="checklist-signoff__placeholder">Signed electronically</span>
						}
					</button>
					@if (candidateSignedAt) {
						<span class="checklist-signoff__signed-at">{{ candidateSignedAt }}</span>
					}
				</div>
			</div>
		</div>
	</section>

	@if (showFeedbackSection) {
		<section class="checklist-signoff__section">
			<div class="checklist-signoff__header">
				<span class="checklist-signoff__header-title">Feedback Questions</span>
			</div>

			<div class="checklist-signoff__body">
				<app-checklist-feedback
					[embedded]="true"
					[template]="feedbackTask!.template"
					[taskId]="feedbackTask!.taskId"
					[submitted]="!feedbackPending"
					(formValidChange)="onFeedbackFormValidChange($event)"
					(completed)="onFeedbackCompleted()"
				></app-checklist-feedback>
			</div>
		</section>
	}

	<div class="checklist-signoff__actions">
		<button type="button" class="aa-btn" data-variant="tertiary" (click)="back.emit()">Back</button>
		<button
			type="button"
			class="aa-btn"
			data-variant="primary"
			[disabled]="completeDisabled || signing"
			(click)="complete.emit()"
		>
			Complete
		</button>
	</div>
</div>
